<template>
  <div>
    <header-admin :active-section="12" />
    <cdr-flag-detail-content
      api-url="/api/internal/admin/cdr/flags/"
      back-route="/admin/cdr/flags"
    />
  </div>
</template>

<script>
import HeaderAdmin from "../Header.vue";
import CdrFlagDetailContent from "../../ClinicalDataRemoval/CdrFlagDetailContent.vue";

export default {
  components: { HeaderAdmin, CdrFlagDetailContent },
};
</script>
